import { render, staticRenderFns } from "./title-return.vue?vue&type=template&id=abc38f80&"
import script from "./title-return.vue?vue&type=script&lang=js&"
export * from "./title-return.vue?vue&type=script&lang=js&"
import style0 from "./title-return.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports